import MenuContainer, { MenuContainerProps } from './MenuContainer';
import { MenuContainerWrapper } from './styles';

export type DesktopMenuProps = MenuContainerProps;

const DesktopMenu: React.FC<DesktopMenuProps> = (props) => (
    <MenuContainerWrapper>
        <MenuContainer {...props} />
    </MenuContainerWrapper>
);

export default DesktopMenu;
